var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    role: "presentation",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.28 6.72-3.03-3.03-3.03 3.03 1.06 1.06 1.22-1.22V11H7.06l1.22-1.22-1.06-1.06-3.03 3.03 3.03 3.03 1.06-1.06-1.22-1.22h4.44v4.439l-1.219-1.22-1.06 1.061 3.03 3.03 3.03-3.03-1.06-1.06L13 16.94V12.5h4.44l-1.22 1.22 1.061 1.06 3.03-3.03-3.03-3.03-1.06 1.06L17.44 11H13V6.56l1.22 1.22 1.06-1.06Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.d4c0099c093e7c9c09bd28139c0dbe38.svg";
export { ForwardRef as ReactComponent };